import { render, staticRenderFns } from "./BonusModal.vue?vue&type=template&id=6b712f4c&scoped=true&"
import script from "./BonusModal.vue?vue&type=script&lang=js&"
export * from "./BonusModal.vue?vue&type=script&lang=js&"
import style0 from "./BonusModal.vue?vue&type=style&index=0&id=6b712f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b712f4c",
  null
  
)

export default component.exports